import React from 'react';

type formattedParts = { formattedPart: string; isMatch: boolean };

export const formatInputWithMatchingSearchTerm = (
    str: string,
    searchTerm: string
): formattedParts[] => {
    if (!str || !searchTerm) return [];
    return str
        .split(new RegExp(`(${searchTerm})`, 'gi'))
        .filter((part) => part !== '')
        .map((part) => {
            let formattedPart = part;
            const startWithSpace = /^[\s]/.test(part);
            formattedPart = startWithSpace ? part.slice(1) : part;

            const partIndex = str.indexOf(formattedPart);
            const shouldPrependSpace =
                partIndex > 1 && str.slice(partIndex - 1, partIndex).trim() === '';

            return {
                formattedPart: `${shouldPrependSpace ? '\u00A0' : ''}${formattedPart}`,
                isMatch: part.toLowerCase() === searchTerm.toLowerCase(),
            };
        });
};

const HighlightSearchMatch = ({ label, searchTerm }) => {
    const formarttedParts = formatInputWithMatchingSearchTerm(label, searchTerm);

    return (
        <>
            {formarttedParts.map((part, index) => {
                const Elem = part.isMatch ? 'strong' : 'span';
                // eslint-disable-next-line react/no-array-index-key
                return <Elem key={index}>{part.formattedPart}</Elem>;
            })}
        </>
    );
};

export default HighlightSearchMatch;
